import axios from 'axios'

const state = {
    serviceEntitiesList: [],
    serviceEntity: []
};

const getters = {
    serviceEntitiesList: state => {
        return state.serviceEntitiesList
    },
    serviceEntity: state => {
        return state.serviceEntity
    }
};

const mutations = {
    serviceEntitiesList: (state, payload) => {
        return state.serviceEntitiesList = payload
    },
    serviceEntity: (state, payload) => {
        return state.serviceEntity = payload
    }
};

const actions = {
//GET
    serviceEntitiesGet({commit}, filters) {
        return axios({
            method: 'GET',
            url: 'svcentity',
            params: {
                name: filters && filters.name ? filters.name : null,
                city: filters && filters.city ? filters.city : null,
                street: filters && filters.street ? filters.street : null,
                pg: 0,
                batch: 100
            }
        })
        .then(({data}) => {
            console.log(data)
            commit('serviceEntitiesList', data.data)
        })
        .catch(err => {
            console.error('Ошибка скачивания списка юрлиц: ', err)
        })
    },
    serviceEntityGet({commit}, id) {
        return axios({
            method: 'GET',
            url: 'svcentity/' + id
        })
        .then(({data}) => {
            commit('serviceEntity', data.data)
        })
        .catch(err => {
            console.error('Ошибка скачивания юрлица: ', err)
        })
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}